import { Tile } from "@src/cloud-connect/blueprint/dashboards/entities/tile";
import { getTileCollection } from "@src/cloud-connect/dependency-injection-container/get-tile-collection";
import { updateGlobalLookForLastTimeStampBeforeFetchingData } from "@src/reducers/your-reducer";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

export interface BlueprintDashboardObj {
  tiles: Tile[];
}

export const useBlueprintDashboardHook = (): BlueprintDashboardObj => {
  const dispatch = useDispatch();

  const [tiles, setTiles] = useState(undefined as Tile[] | undefined);

  const resetGlobalLookForLastTimeStampBeforeFetchingDataToDefaultValue =
    () => {
      dispatch(updateGlobalLookForLastTimeStampBeforeFetchingData(false));
    };

  useEffect(() => {
    resetGlobalLookForLastTimeStampBeforeFetchingDataToDefaultValue();
    setTiles(
      getTileCollection()
        .getTiles()
        .sort((a, b) => a.getPosition() - b.getPosition()),
    );
  }, []);

  return {
    tiles: tiles,
  };
};
